import { render, staticRenderFns } from "./NewOrEditCourseComponent.vue?vue&type=template&id=34a0c6e0&scoped=true&"
import script from "./NewOrEditCourseComponent.vue?vue&type=script&lang=js&"
export * from "./NewOrEditCourseComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a0c6e0",
  null
  
)

export default component.exports